/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_Detail_Beginner_1_HeadingInputs */

const en_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let your head and eyes follow the ball`)
};

const es_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja que la cabeza y los ojos sigan la bola`)
};

const de_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lassen Sie Ihren Kopf und Ihre Augen dem Ball folgen`)
};

const zh_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让头和眼睛跟着球走`)
};

const ar_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دع رأسك وعينيك يتبعان الكرة`)
};

const fr_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez votre tête et vos yeux suivre la balle`)
};

const vi_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để đầu và mắt theo bóng`)
};

const sw_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acha kichwa na macho yako vifuatilie mpira`)
};

const th_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปล่อยให้ศีรษะและสายตาตามลูกไป`)
};

const bs_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neka glava i oči prate loptu`)
};

const ja_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`頭と目でボールを追う`)
};

const ko_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`머리와 눈이 공을 따라가게 하세요`)
};

const pt_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe a cabeça e os olhos seguirem a bola`)
};

const it_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia che testa e occhi seguano la palla`)
};

const sv_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Låt huvudet och blicken följa bollen`)
};

const nl_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat je hoofd en ogen de bal volgen`)
};

const da_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lad hovedet og øjnene følge bolden`)
};

const nb_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La hodet og blikket følge ballen`)
};

const fi_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna pään ja katseen seurata palloa`)
};

const pl_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozwól głowie i oczom podążać za piłką`)
};

const ru_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пусть голова и глаза следуют за мячом`)
};

const tr_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başınızın ve gözlerinizin topu takip etmesine izin verin`)
};

const hi_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिर और आँखों को गेंद के पीछे जाने दीजिए`)
};

const id_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biarkan kepala dan mata Anda mengikuti bola`)
};

const ms_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biarkan kepala dan mata anda mengekori bola`)
};

const cs_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nechte hlavu a oči sledovat míč`)
};

const el_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αφήστε το κεφάλι και τα μάτια να ακολουθήσουν την μπάλα`)
};

const he_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תנו לראש ולעיניים לעקוב אחרי הכדור`)
};

const af_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat jou kop en oë die bal volg`)
};

const hu_method_content_step_04_detail_beginner_1_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hagyd, hogy a fejed és a szemed kövesse a labdát`)
};

/**
* | output |
* | --- |
* | "Let your head and eyes follow the ball" |
*
* @param {Method_Content_Step_04_Detail_Beginner_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_detail_beginner_1_heading = /** @type {((inputs?: Method_Content_Step_04_Detail_Beginner_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_Detail_Beginner_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "de") return de_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "th") return th_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "it") return it_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "da") return da_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "id") return id_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "el") return el_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "he") return he_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "af") return af_method_content_step_04_detail_beginner_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_04_detail_beginner_1_heading(inputs)
	return en_method_content_step_04_detail_beginner_1_heading(inputs)
});